// extracted by mini-css-extract-plugin
export default {"list":"Variants_list__qRhDB"};